export default "__VITE_ASSET__C9VRZo0J__"